
import React from 'react';
import { Link } from 'react-router-dom';
import CONSTANT from './../../../constant';
import { getUserList } from './../../../actions/UserAction';
import Header from '../../../component/common/AdminHeader';
import Paging from '../../../component/common/Paging';
import { getDateParts } from '../../../utils';
import { getUnitList } from '../../../actions/MasterAction';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            page: 1,
            limit: 10,
            list: undefined
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;

        this.loadList();
    }

    render() {
        const { page, list } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className='card homedob'>
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 className="page-title">All Unit</h1>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <Link to={CONSTANT.component.adminAddUnitList.url} className="btn btn-sm submit-button">
                                        <i className="fa fa-plus-circle mr-2" />
                                        Add Unit
                                    </Link>
                                </div>
                                <div className="col-md-6">
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mt-3">
                                    <div className="list-container">
                                        <div className="table-container">
                                        <div className="table-wrapper radius-4">
                                        <table className="tablen">
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="text-nowrap">#</th>
                                                    <th scope="col" className="text-nowrap">Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    list === undefined && 
                                                    <tr>
                                                        <td colSpan={2} className="text-center">Loading...</td>
                                                    </tr>
                                                }
                                                {
                                                    list !== undefined && list.length === 0 && 
                                                    <tr>
                                                        <td colSpan={2} className="text-center">No records found</td>
                                                    </tr>
                                                }
                                                {
                                                    list !== undefined && list.map((item: any, index: number) => {
                                                        const detailPageURL = CONSTANT.component.adminEditUser.url.replace(':code', item.code);
                                                        const dated = getDateParts(item.modifiedOn);
                                                        return (
                                                            <tr className="c-pointer" >
                                                                <td>{index + 1}</td>
                                                                <td>{item.name}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    loadList = () => {
        getUnitList().then((res: any) => {
            if(res)
            this.setState({ list: res.result });
        });
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }

    changePage = (e: any) => {
        const type = e.target.dataset.type;
        const page = type === '+' ? this.state.page + 1 : this.state.page - 1;
        this.setState({ page }, () => { this.loadList() });
    }
}

export default ComponentName;